/**
 * Loads an image from a given URL and returns its natural width and height (can be extended to return more information if needed)
 *
 * @param {string} url - The URL of the image to load.
 * @returns {Promise<{ naturalWidth: number; naturalHeight: number }>} A Promise that resolves with an object containing the natural width and height of the image.
 * @throws Will reject the Promise if an error occurs while loading the image.
 */
export const loadImageData = (url: string): Promise<{ naturalWidth: number; naturalHeight: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;

      img.onload = null;
      img.onerror = null;
      img.src = '';

      return resolve({ naturalWidth, naturalHeight });
    };

    img.onerror = (event) => {
      img.onload = null;
      img.onerror = null;
      img.src = '';

      return reject('Unable to load image');
    };

    img.crossOrigin = 'Anonymous';
    img.src = url;
  });
};
